var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/20/icon_tile_view") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,5 L11.5714286,5 C12.6759981,5 13.5714286,5.8954305 13.5714286,7 L13.5714286,11.5714286 C13.5714286,12.6759981 12.6759981,13.5714286 11.5714286,13.5714286 L7,13.5714286 C5.8954305,13.5714286 5,12.6759981 5,11.5714286 L5,7 C5,5.8954305 5.8954305,5 7,5 Z M7,16.4285714 L11.5714286,16.4285714 C12.6759981,16.4285714 13.5714286,17.3240019 13.5714286,18.4285714 L13.5714286,23 C13.5714286,24.1045695 12.6759981,25 11.5714286,25 L7,25 C5.8954305,25 5,24.1045695 5,23 L5,18.4285714 C5,17.3240019 5.8954305,16.4285714 7,16.4285714 Z M18.4285714,16.4285714 L23,16.4285714 C24.1045695,16.4285714 25,17.3240019 25,18.4285714 L25,23 C25,24.1045695 24.1045695,25 23,25 L18.4285714,25 C17.3240019,25 16.4285714,24.1045695 16.4285714,23 L16.4285714,18.4285714 C16.4285714,17.3240019 17.3240019,16.4285714 18.4285714,16.4285714 Z M18.4285714,5 L23,5 C24.1045695,5 25,5.8954305 25,7 L25,11.5714286 C25,12.6759981 24.1045695,13.5714286 23,13.5714286 L18.4285714,13.5714286 C17.3240019,13.5714286 16.4285714,12.6759981 16.4285714,11.5714286 L16.4285714,7 C16.4285714,5.8954305 17.3240019,5 18.4285714,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Role-management-list",
    transform: "translate(-1285.000000, -223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1280.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#dd7636",
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleView);
export default __webpack_public_path__ + "static/media/title_view.0d33a7f3781d616b4faa460171d60771.svg";
export { ForwardRef as ReactComponent };